import {
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Sheet,
  SheetBody,
  SheetContent,
  Typography,
} from "@suraasa/placebo-ui"
import { useMediaQuery } from "@uidotdev/usehooks"
import finalStepBg from "assets/masterclass/final-step-bg.webp"
import { Xmark } from "iconoir-react"

const FinalStep = ({
  open,
  handleFinish,
  hasUpcomingMasterclass,
}: {
  open: boolean
  handleFinish: () => void
  hasUpcomingMasterclass?: boolean
}) => {
  const isSmDown = useMediaQuery("only screen and (max-width : 599px)")

  const Content = (
    <div className="relative rounded-xl p-0">
      <IconButton
        className="absolute right-2 top-2 size-4 rounded-lg bg-onSurface-400/10 hover:bg-onSurface-400/30"
        onClick={handleFinish}
        autoFocus={false}
      >
        <Xmark className="!size-2 text-onSurface-800" strokeWidth={2} />
      </IconButton>

      <div className="flex flex-col gap-1.5 p-3">
        <div className="w-full">
          <img src={finalStepBg} alt="" className="h-10" />
        </div>

        <Typography variant="title2" className="mt-3">
          Why Masterclasses Matter
        </Typography>
        <ul className="mb-1 list-disc pl-2 pt-1 text-largeBody text-onSurface-600">
          <li>
            Meet your CPD goals and advance your professional development.
          </li>
          <li>
            Earn certificates for every <strong>Live Masterclass</strong> and
            strengthen your resume.
          </li>
        </ul>

        <div className="mt-4 flex items-center justify-between">
          <Typography variant="preTitle" className="text-muted">
            {hasUpcomingMasterclass ? "6 of 6" : "4 of 4"}
          </Typography>

          <Button color="black" autoFocus onClick={handleFinish}>
            Finish Tour
          </Button>
        </div>
      </div>
    </div>
  )
  if (isSmDown) {
    return (
      <Sheet open={open}>
        <SheetContent height={78} className="!p-0">
          <SheetBody className="!p-0">{Content}</SheetBody>
        </SheetContent>
      </Sheet>
    )
  }
  return (
    <Dialog open={open} onOpenChange={handleFinish}>
      <DialogContent
        className="bg-white !p-0"
        aria-describedby="dialog-description"
      >
        {Content}
      </DialogContent>
    </Dialog>
  )
}

export default FinalStep
